import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './App';
import sentryService from './services/sentry.service';

(async function initApp() {
  const isRemoteEnv = import.meta.env.VITE_DEPLOYMENT_TARGET !== 'LOCAL';
  if (isRemoteEnv) {
    sentryService.init();
    // Global error/rejection handlers provided by Sentry's globalHandlersIntegration (enabled by default)
  }

  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  root.render(
    <StrictMode>
      <App />
    </StrictMode>
  );
})();
